import * as Types from "./types";

export const seriesColors: Array<Types.ChartColor> = [
  // REDS
  { name: "Red1", color: { a: 255, r: 200, g: 30, b: 45 } },
  { name: "Red2", color: { a: 255, r: 255, g: 60, b: 60 } },
  { name: "Red3", color: { a: 255, r: 180, g: 70, b: 90 } },
  { name: "Red4", color: { a: 255, r: 140, g: 40, b: 60 } },

  // YELLOWS
  { name: "Yellow1", color: { a: 255, r: 255, g: 200, b: 0 } },
  { name: "Yellow2", color: { a: 255, r: 240, g: 170, b: 20 } },
  { name: "Yellow3", color: { a: 255, r: 200, g: 150, b: 0 } },
  { name: "Yellow4", color: { a: 255, r: 160, g: 120, b: 20 } },

  // GREENS
  { name: "Green1", color: { a: 255, r: 30, g: 180, b: 50 } },
  { name: "Green2", color: { a: 255, r: 90, g: 220, b: 90 } },
  { name: "Green3", color: { a: 255, r: 60, g: 160, b: 80 } },
  { name: "Green4", color: { a: 255, r: 30, g: 110, b: 50 } },

  // BLUES
  { name: "Blue1", color: { a: 255, r: 50, g: 100, b: 255 } },
  { name: "Blue2", color: { a: 255, r: 100, g: 150, b: 255 } },
  { name: "Blue3", color: { a: 255, r: 80, g: 120, b: 200 } },
  { name: "Blue4", color: { a: 255, r: 30, g: 70, b: 160 } },

  // ORANGES
  { name: "Orange1", color: { a: 255, r: 255, g: 120, b: 0 } },
  { name: "Orange2", color: { a: 255, r: 240, g: 100, b: 20 } },
  { name: "Orange3", color: { a: 255, r: 220, g: 90, b: 30 } },
  { name: "Orange4", color: { a: 255, r: 180, g: 70, b: 20 } },

  // PURPLES
  { name: "Purple1", color: { a: 255, r: 180, g: 100, b: 255 } },
  { name: "Purple2", color: { a: 255, r: 150, g: 80, b: 220 } },
  { name: "Purple3", color: { a: 255, r: 120, g: 70, b: 190 } },
  { name: "Purple4", color: { a: 255, r: 100, g: 50, b: 160 } },

  // PINKS
  { name: "Pink1", color: { a: 255, r: 255, g: 100, b: 180 } },
  { name: "Pink2", color: { a: 255, r: 240, g: 80, b: 150 } },
  { name: "Pink3", color: { a: 255, r: 220, g: 70, b: 130 } },
  { name: "Pink4", color: { a: 255, r: 180, g: 50, b: 100 } },

  // BROWNS
  { name: "Brown1", color: { a: 255, r: 160, g: 82, b: 45 } },
  { name: "Brown2", color: { a: 255, r: 140, g: 70, b: 35 } },
  { name: "Brown3", color: { a: 255, r: 120, g: 60, b: 30 } },
  { name: "Brown4", color: { a: 255, r: 100, g: 50, b: 25 } },

  // GRAYS
  { name: "Gray1", color: { a: 255, r: 220, g: 220, b: 220 } },
  { name: "Gray2", color: { a: 255, r: 160, g: 160, b: 160 } },
  { name: "Gray3", color: { a: 255, r: 100, g: 100, b: 100 } },
  { name: "Gray4", color: { a: 255, r: 60, g: 60, b: 60 } },

  // CYANS
  { name: "Cyan1", color: { a: 255, r: 0, g: 200, b: 200 } },
  { name: "Cyan2", color: { a: 255, r: 40, g: 180, b: 200 } },
  { name: "Cyan3", color: { a: 255, r: 30, g: 160, b: 180 } },
  { name: "Cyan4", color: { a: 255, r: 20, g: 130, b: 160 } },

  // TEALS
  { name: "Teal1", color: { a: 255, r: 0, g: 160, b: 160 } },
  { name: "Teal2", color: { a: 255, r: 0, g: 130, b: 130 } },
  { name: "Teal3", color: { a: 255, r: 30, g: 110, b: 110 } },
  { name: "Teal4", color: { a: 255, r: 20, g: 90, b: 90 } }
];

// export const seriesColors: Array<Types.ChartColor> = [
//   {
//     name: "Red1",
//     color: {
//       a: 255,
//       r: 255,
//       g: 0,
//       b: 0
//     }
//   },
//   {
//     name: "Red2",
//     color: {
//       a: 255,
//       r: 150,
//       g: 0,
//       b: 59
//     }
//   },
//   {
//     name: "Red3",
//     color: {
//       a: 255,
//       r: 255,
//       g: 110,
//       b: 110
//     }
//   },
//   {
//     name: "Red4",
//     color: {
//       a: 255,
//       r: 255,
//       g: 59,
//       b: 0
//     }
//   },
//   {
//     name: "Blue1",
//     color: {
//       a: 255,
//       r: 0,
//       g: 0,
//       b: 255
//     }
//   },
//   {
//     name: "Blue2",
//     color: {
//       a: 255,
//       r: 59,
//       g: 0,
//       b: 150
//     }
//   },
//   {
//     name: "Blue3",
//     color: {
//       a: 255,
//       r: 110,
//       g: 110,
//       b: 255
//     }
//   },
//   {
//     name: "Blue4",
//     color: {
//       a: 255,
//       r: 59,
//       g: 0,
//       b: 255
//     }
//   },
//   {
//     name: "Yellow1",
//     color: {
//       a: 255,
//       r: 255,
//       g: 255,
//       b: 0
//     }
//   },
//   {
//     name: "Yellow2",
//     color: {
//       a: 255,
//       r: 200,
//       g: 200,
//       b: 0
//     }
//   },
//   {
//     name: "Yellow3",
//     color: {
//       a: 255,
//       r: 220,
//       g: 180,
//       b: 0
//     }
//   },
//   {
//     name: "Green1",
//     color: {
//       a: 255,
//       r: 64,
//       g: 255,
//       b: 0
//     }
//   },
//   {
//     name: "Green2",
//     color: {
//       a: 255,
//       r: 64,
//       g: 192,
//       b: 64
//     }
//   },
//   {
//     name: "Green3",
//     color: {
//       a: 255,
//       r: 0,
//       g: 128,
//       b: 64
//     }
//   }
// ];
